import { Box, Stack, TextField } from '@mui/material';
import { grey } from '@mui/material/colors';
import { memo } from 'react';
import PropTypes from 'prop-types';

const AppVersionLog = ({
  title,
  fieldKey,
  errorText,
  valueText,
  setFieldValue,
  disabled = false,
}) => {
  return (
    <Stack direction='column' spacing={2}>
      <Box component='p' color='text.primary' fontSize={14}>
        {title}
      </Box>
      <TextField
        disabled={disabled}
        multiline
        rows={4}
        placeholder='Enter text'
        name={fieldKey}
        error={!!errorText}
        helperText={errorText}
        value={valueText ?? ''}
        onChange={async (e) => {
          setFieldValue(fieldKey, e.target.value);
        }}
        onBlur={(e) => {
          setFieldValue(fieldKey, valueText?.trim());
        }}
        fullWidth
        minRows={4}
        sx={{ '& .Mui-disabled': { backgroundColor: grey[50] } }}
      />
    </Stack>
  );
};

export default memo(AppVersionLog);

AppVersionLog.propTypes = {
  title: PropTypes.string,
  fieldKey: PropTypes.string,
  errorText: PropTypes.string,
  valueText: PropTypes.string,
  setFieldValue: PropTypes.func,
  disabled: PropTypes.bool,
};
